<script>
	export let event = () => {};
	export let row = {};
	export let key = "";
	export let action = "";

	let icons = {
		edit: "/assets/icon-pen.svg",
		view: "/assets/icon-eye.svg",
	};
</script>

<img
	src={icons[action]}
	alt="action-icon"
	tabindex="0"
	on:click={() => event(row.id)}
	on:keydown={(e) => e.key === "Enter" && event()}
	class="action-icon"
/>

<style>
	.action-icon:hover {
		cursor: pointer;
	}
</style>
